const actions = {
    // deklaracje
    GET_SENT_DEKLARACJE: "sent/GET_SENT_DEKLARACJE",
    SET_SENT_DEKLARACJE: "sent/SET_SENT_DEKLARACJE",
    SET_SENT_DEKLARACJE_LOADING: "sent/SET_SENT_DEKLARACJE_LOADING",
    SET_SENT_DEKLARACJE_ERROR: "sent/SET_SENT_DEKLARACJE_ERROR",

    // pojazdy uprawnione
    GET_SENT_POJAZDY: "sent/GET_SENT_POJAZDY",
    SET_SENT_POJAZDY: "sent/SET_SENT_POJAZDY",
    SET_SENT_POJAZDY_LOADING: "sent/SET_SENT_POJAZDY_LOADING",
    SET_SENT_POJAZDY_ERROR: "sent/SET_SENT_POJAZDY_ERROR",

    // zapis i usuwanie
    POST_SENT_DEKLARACJA: "sent/POST_SENT_DEKLARACJA",
    DELETE_SENT_DEKLARACJA: "sent/DELETE_SENT_DEKLARACJA",
    SET_SENT_ZAPIS: "sent/SET_SENT_ZAPIS",

    SET_INITIAL_SENT: "sent/SET_INITIAL_SENT"
};

export default actions;
